import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, MISC } from '@const'
import * as utils from '@utils'
import { Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@material-ui/core'
import { TextField } from '@prototype'
import { DatetimeSelect } from '@select'
import { Edit, Delete } from '@material-ui/icons'
import RedPacketDialog from './redPacket'
import DragonBoardDialog from './dragonBoard'
import TigerBoardDialog from './tigerBoard'
import { ConfirmMsgDialog } from '@msg'
import MaterialTable from 'material-table'


class EventDoppelgangerDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EventDoppelgangerDialog', options)
        }
        this.state = {
            dialogOpen: false,
            type: '',
            name: '',
            eventID: '',
            joinedGameCodeList: [],
            eventInfo: {},
            editRedPacketDialog: false,
            redPacketDialogOptions: {
                type: 'add',
                eventID: '',
                detail: {}
            },
            editDragonBoardDialog: false,
            dragonBoardDialogOptions: {
                type: 'add',
                eventID: '',
                detail: {}
            },
            editTigerBoardDialog: false,
            tigerBoardDialogOptions: {
                type: 'add',
                eventID: '',
                detail: {}
            },
            redPacketTableData: [],
            dragonBoardTableData: [],
            tigerBoardTableData: [],
            isLoading: false,
            redPacketLoading: false,
            dragonLoading: false,
            tigerLoading: false
        }
    }

    redPacketTableColumns = [
        {
            field: 'pf_account',
            title: utils.t('pf_account'),
            cellStyle: {'textAlign': 'center'},
            headerStyle: {'textAlign': 'center'}

        },
        {
            field: 'consume_points',
            title: utils.t('lotteryThreshold', 'EventDoppelgangerDialog'),
            cellStyle: {'textAlign': 'center'},
            headerStyle: {'textAlign': 'center'}
        },
        {
            field: 'bonus',
            title: utils.t('amountCollected', 'EventDoppelgangerDialog'),
            cellStyle: {'textAlign': 'center'},
            headerStyle: {'textAlign': 'center'}
        },
        {
            title: utils.t('actions'),
            headerStyle: {'textAlign': 'center'},
            sorting: false,
            render: (rowData) => (
                <div style={{textAlign: 'center'}}>
                    <Delete
                        className={this.props.classes.actionsBtn}
                        onClick={() => {
                            this.confirmDialog.OpenDialog({
                                type: 'warn',
                                msg: `${utils.t('account')}：${rowData.pf_account} ${this.t('confirmDeleteMsg')}`,
                                confirm: () => {
                                    const accountList = [rowData.pf_account]
                                    this.handleDeleteAccount(accountList, 'redPacket')
                                },
                            })
                        }} 
                    />
                </div>
            ),
        }
    ]
    dragonBoardTableColumns = [
        {
            field: 'ranking',
            title: utils.t('ranking', 'EventDoppelgangerDialog'),
            cellStyle: {'textAlign': 'center'},
            headerStyle: {'textAlign': 'center'},
            sorting: false,
            render: (rowData) => rowData.rank
        },
        {
            field: 'account',
            title: utils.t('account'),
            cellStyle: {'textAlign': 'center'},
            headerStyle: {'textAlign': 'center'},
            sorting: false
        },
        {
            field: 'amount',
            title: utils.t('currentBetAmount', 'EventDoppelgangerDialog'),
            cellStyle: {'textAlign': 'center'},
            headerStyle: {'textAlign': 'center'},
            sorting: false,
            render: (rowData) => rowData.threshold_grand_total
        },
        {
            title: utils.t('actions'),
            headerStyle: {'textAlign': 'center'},
            sorting: false,
            render: (rowData) => (
                <div style={{textAlign: 'center'}}>
                    <Edit
                        color="primary"
                        className={this.props.classes.actionsBtn}
                        onClick={() => {
                            const dragonBoardDialogOptions = Object.assign({},this.state.dragonBoardDialogOptions)
                            dragonBoardDialogOptions.eventID = this.state.eventID
                            dragonBoardDialogOptions.type = 'edit'
                            dragonBoardDialogOptions.detail = rowData
                            this.setState({
                                editDragonBoardDialog: true,
                                dragonBoardDialogOptions
                            })
                        }} 
                    />
                    <Delete
                        color="primary"
                        className={this.props.classes.actionsBtn}
                        onClick={() => {
                            this.confirmDialog.OpenDialog({
                                type: 'warn',
                                msg: `${utils.t('account')}：${rowData.account} ${this.t('confirmDeleteMsg')}`,
                                confirm: () => {
                                    const accountList = [rowData.account]
                                    this.handleDeleteAccount(accountList, 'dragonBoard')
                                },
                            })
                        }} 
                    />
                </div>
            ),
        }
    ]
    tigerBoardTableColumns = [
        {
            field: 'ranking',
            title: utils.t('ranking', 'EventDoppelgangerDialog'),
            cellStyle: {'textAlign': 'center'},
            headerStyle: {'textAlign': 'center'},
            sorting: false,
            render: (rowData) => rowData.rank
        },
        {
            field: 'account',
            title: utils.t('account'),
            cellStyle: {'textAlign': 'center'},
            headerStyle: {'textAlign': 'center'},
            sorting: false
        },
        {
            field: 'game_name',
            title: utils.t('gameName'),
            cellStyle: {'textAlign': 'center'},
            headerStyle: {'textAlign': 'center'},
            sorting: false,
            render: (rowData) => (utils.getGameName(rowData.game_code))
        },
        {
            field: 'magnification',
            title: utils.t('magnification', 'EventDoppelgangerDialog'),
            cellStyle: {'textAlign': 'center'},
            headerStyle: {'textAlign': 'center'},
            sorting: false,
            render: (rowData) => rowData.threshold
        },
        {
            title: utils.t('actions'),
            headerStyle: {'textAlign': 'center'},
            sorting: false,
            render: (rowData) => (
                <div style={{textAlign: 'center'}}>
                    <Delete
                        color="primary"
                        className={this.props.classes.actionsBtn}
                        onClick={() => {
                            this.confirmDialog.OpenDialog({
                                type: 'warn',
                                msg: `${utils.t('account')}：${rowData.account} ${this.t('confirmDeleteMsg')}`,
                                confirm: () => {
                                    const accountList = [rowData.account]
                                    this.handleDeleteAccount(accountList, 'tigerBoard')
                                },
                            })
                        }}
                    />
                </div>
            ),
        }
    ]

    options = {
        search: false,
        pageSize: 10,
        pageSizeOptions: [10, 30, 50, 100],
        showTitle: false,
    }

    componentDidMount() {
        const { type, event_id, eventInfo, joinedGameCodeList } = this.props.doppelganger
        this.setState({
            dialogOpen: true,
            type,
            eventID: event_id,
            eventInfo: eventInfo,
            name: eventInfo.name,
            joinedGameCodeList
        }, ()=>{
            setTimeout(() => {
                this.datetimeSelect.setState({
                    startDisabled: true,
                    endDisabled: true,
                    startDate: utils.unixToDateTime(eventInfo['start_at']),
                    endDate: utils.unixToDateTime(eventInfo['end_at']),
                },()=>{
                    this.queryData()
                })
            })
        })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
        this.props.closeDialog()
    }

    queryData() {
        this.setState({
            isLoading: true
        })
        const promiseList = []
        if (this.state.type === MISC.EVENT_RED_PACKET) {
            /** 紅包 */
            promiseList.push(
                new Promise((resolve)=>{
                    this.handleGetRedPacket(resolve)
                })
            )
        } else if (this.state.type === MISC.EVENT_DRAGON_TIGER_BOARD) {
            /** 龍榜 */
            promiseList.push(
                new Promise((resolve)=>{
                    this.handleGetDragon(resolve)
                })
            )
            /** 虎榜 */
            promiseList.push(
                new Promise((resolve)=>{
                    this.handleGetTiger(resolve)
                })
            )
        }
        Promise.all(promiseList).then((resp) => {
            if (this.state.type === MISC.EVENT_RED_PACKET) {
                this.setState({
                    redPacketTableData: resp[0] ? resp[0] : [],
                    isLoading: false
                })
            } else if(this.state.type === MISC.EVENT_DRAGON_TIGER_BOARD) {
                this.setState({
                    dragonBoardTableData: resp[0] ? this.handleDragonTigerBoardSort(resp[0], 'threshold_grand_total') : [],
                    tigerBoardTableData: resp[1] ? this.handleDragonTigerBoardSort(resp[1], 'threshold') : [],
                    isLoading: false
                })
            }
        })
    }
    /** 龍虎榜名次排序 */
    handleDragonTigerBoardSort(list, key) {
        list.sort((a, b)=> {
            const aRank = Number(a.rank)
            const bRank = Number(b.rank)
            const aThreshold = Number(a[key])
            const bThreshold = Number(b[key])
            /** rank 排序小到大, 有rank在前, 剩餘以key值排序 */
            if (aRank && bRank) {
                if (aRank > bRank) {
                    return 1
                }
                if (aRank < bRank) {
                    return -1
                }
            } else if (aRank && !bRank) {
                return -1
            } else if (!aRank && bRank) {
                return 1
            }
            if (aThreshold > bThreshold) {
                return -1
            }
            if (aThreshold < bThreshold) {
                return 1
            }
            return 0
        })
        return list
    }
    /** 抽紅包取得馬甲列表 */
    handleGetRedPacket(callBack) {
        utils.apiRequest(
            'get',
            API.FAKEACCOUNT_RED_PACKET,
            {event_id: this.state.eventID},
            (data) => {
                data.sort((a,b) => {
                    return b.amount - a.amount
                })
                if (callBack) {
                    callBack(data)
                }
            },
            (_err) => {
                if (callBack) {
                    callBack([])
                }
            },
            true
        )
    }
    /** 龍榜取得馬甲列表 */
    handleGetDragon(callBack) {
        utils.apiRequest(
            'get',
            API.FAKEACCOUNT_DRAGON,
            {event_id: this.state.eventID},
            (data) => {
                data.sort((a,b) => {
                    return b.threshold_grand_total - a.threshold_grand_total
                })
                if (callBack) {
                    callBack(data)
                }
            },
            (_err) => {
                if (callBack) {
                    callBack([])
                }
            },
            true
        )
    }
    /** 虎榜取得馬甲列表 */
    handleGetTiger(callBack) {
        utils.apiRequest(
            'get',
            API.FAKEACCOUNT_TIGER,
            {event_id: this.state.eventID},
            (data) => {
                data.sort((a,b) => {
                    return b.threshold - a.threshold
                })
                if (callBack) {
                    callBack(data)
                }
            },
            (_err) => {
                if (callBack) {
                    callBack([])
                }
            },
            true
        )
    }

    /** 刪除馬甲帳號 */
    handleDeleteAccount(accountList, type) {
        let apiUrl = ''
        switch(type) {
            case 'dragonBoard':
                apiUrl = API.FAKEACCOUNT_DRAGON
                break
            case 'tigerBoard':
                apiUrl = API.FAKEACCOUNT_TIGER
                break
            default:
                /** 預設抽紅包 */
                apiUrl = API.FAKEACCOUNT_RED_PACKET
                break
        }
        utils.apiRequest(
            'delete',
            apiUrl,
            {
                event_id: this.state.eventID,
                account: accountList
            },
            (_data) => {
                this.confirmDialog.closeDialog()
                this.queryData()
            },
            (_err) => {
                this.confirmDialog.closeDialog()
            }
        )
    }

    render() {
        return (
            <>
                <Dialog open={this.state.dialogOpen} onClose={() => {return false}} fullWidth maxWidth={this.state.type === 'dragonTigerBoard' ?'xl':'md'} disableEscapeKeyDown={true}>
                    <DialogTitle>{this.t('doppelgangerSet')}</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={this.state.type === MISC.EVENT_RED_PACKET ? 4 : 2}>
                                <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.textField}
                                        label={this.t('name')}
                                        value={this.state.name}
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <DatetimeSelect
                                        onRef={(ref) => (this.datetimeSelect = ref)}
                                    />
                                </Grid>
                            </Grid>
                            {this.state.type === MISC.EVENT_RED_PACKET && (
                                <Grid item xs={8}>
                                    <MaterialTable
                                        style={{ marginLeft: '10px' }}
                                        columns={this.redPacketTableColumns}
                                        data={this.state.redPacketTableData}
                                        options={{
                                            ...this.options,
                                            showTitle: true,
                                            selection: true,
                                        }}
                                        actions={[
                                            {
                                                text: '',
                                                icon: 'refresh',
                                                isFreeAction: true,
                                                onClick: () => {
                                                    this.setState({
                                                        redPacketLoading: true
                                                    })
                                                    this.handleGetRedPacket((resp)=>{
                                                        this.setState({
                                                            redPacketTableData: resp ? resp : [],
                                                            redPacketLoading: false
                                                        })
                                                    })
                                                }
                                            },
                                            {
                                                text: '',
                                                icon: 'add_box',
                                                isFreeAction: true,
                                                onClick: () => {
                                                    const redPacketDialogOptions = Object.assign({},this.state.redPacketDialogOptions)
                                                    redPacketDialogOptions.eventID = this.state.eventID
                                                    redPacketDialogOptions.type = 'add'
                                                    this.setState({
                                                        editRedPacketDialog: true,
                                                        redPacketDialogOptions
                                                    })
                                                }
                                            },
                                            {
                                                text: '',
                                                icon: 'delete',
                                                onClick: (_evt, data) => {
                                                    const accountList = data.map(item => item.pf_account)
                                                    this.confirmDialog.OpenDialog({
                                                        type: 'warn',
                                                        msg: `${this.t('pf_account')}：\n${accountList.join('\n')}\n${this.t('confirmDeleteMsg')}`,
                                                        confirm: () => {
                                                            this.handleDeleteAccount(accountList, 'redPacket')
                                                        },
                                                    })
                                                },
                                            }
                                        ]}
                                        title={this.t('doppelgangerList')}
                                        isLoading={this.state.isLoading || this.state.redPacketLoading}
                                        localization={{
                                            toolbar: {
                                                nRowsSelected: this.t('selectDoppelganger')
                                            },
                                            body: {
                                                emptyDataSourceMessage: this.t('noRecordsToDisplay'),
                                            },
                                        }}
                                    />
                                </Grid>
                            )}
                            {this.state.type === MISC.EVENT_DRAGON_TIGER_BOARD && (
                                <>
                                    <Grid item xs={5}>
                                        <MaterialTable
                                            style={{ marginLeft: '10px' }}
                                            columns={this.dragonBoardTableColumns}
                                            data={this.state.dragonBoardTableData}
                                            options={{
                                                ...this.options,
                                                showTitle: true,
                                                selection: true
                                            }}
                                            actions={[
                                                {
                                                    text: '',
                                                    icon: 'refresh',
                                                    isFreeAction: true,
                                                    onClick: () => {
                                                        this.setState({
                                                            dragonLoading: true
                                                        })
                                                        this.handleGetDragon((resp)=>{
                                                            this.setState({
                                                                dragonBoardTableData: resp ? resp : [],
                                                                dragonLoading: false
                                                            })
                                                        })
                                                    }
                                                },
                                                {
                                                    text: '',
                                                    icon: 'add_box',
                                                    isFreeAction: true,
                                                    onClick: () => {
                                                        const dragonBoardDialogOptions = Object.assign({},this.state.dragonBoardDialogOptions)
                                                        dragonBoardDialogOptions.eventID = this.state.eventID
                                                        dragonBoardDialogOptions.type = 'add'
                                                        this.setState({
                                                            editDragonBoardDialog: true,
                                                            dragonBoardDialogOptions
                                                        })
                                                    }
                                                },
                                                {
                                                    text: '',
                                                    icon: 'delete',
                                                    onClick: (_evt, data) => {
                                                        const accountList = data.map(item => item.account)
                                                        this.confirmDialog.OpenDialog({
                                                            type: 'warn',
                                                            msg: `${this.t('account')}：\n${accountList.join('\n')}\n${this.t('confirmDeleteMsg')}`,
                                                            confirm: () => {
                                                                this.handleDeleteAccount(accountList, 'dragonBoard')
                                                            },
                                                        })
                                                    },
                                                }
                                            ]}
                                            title={this.t('dragonDoppelgangerList')}
                                            isLoading={this.state.isLoading || this.state.dragonLoading}
                                            localization={{
                                                body: {
                                                    emptyDataSourceMessage: this.t('noRecordsToDisplay'),
                                                },
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={5}>
                                    <MaterialTable
                                            style={{ marginLeft: '10px' }}
                                            columns={this.tigerBoardTableColumns}
                                            data={this.state.tigerBoardTableData}
                                            options={{
                                                ...this.options,
                                                showTitle: true,
                                                selection: true
                                            }}
                                            actions={[
                                                {
                                                    text: '',
                                                    icon: 'refresh',
                                                    isFreeAction: true,
                                                    onClick: () => {
                                                        this.setState({
                                                            tigerLoading: true
                                                        })
                                                        this.handleGetTiger((resp)=>{
                                                            this.setState({
                                                                tigerBoardTableData: resp ? resp : [],
                                                                tigerLoading: false
                                                            })
                                                        })
                                                    }
                                                },
                                                {
                                                    text: '',
                                                    icon: 'add_box',
                                                    isFreeAction: true,
                                                    onClick: () => {
                                                        const tigerBoardDialogOptions = Object.assign({},this.state.tigerBoardDialogOptions)
                                                        tigerBoardDialogOptions.eventID = this.state.eventID
                                                        tigerBoardDialogOptions.type = 'add'
                                                        tigerBoardDialogOptions.gameList = this.state.joinedGameCodeList
                                                        this.setState({
                                                            editTigerBoardDialog: true,
                                                            tigerBoardDialogOptions
                                                        })
                                                    }
                                                },
                                                {
                                                    text: '',
                                                    icon: 'delete',
                                                    onClick: (_evt, data) => {
                                                        const accountList = data.map(item => item.account)
                                                        this.confirmDialog.OpenDialog({
                                                            type: 'warn',
                                                            msg: `${this.t('account')}：\n${accountList.join('\n')}\n${this.t('confirmDeleteMsg')}`,
                                                            confirm: () => {
                                                                this.handleDeleteAccount(accountList, 'tigerBoard')
                                                            },
                                                        })
                                                    },
                                                }
                                            ]}
                                            title={this.t('tigerDoppelgangerList')}
                                            isLoading={this.state.isLoading || this.state.tigerLoading}
                                            localization={{
                                                body: {
                                                    emptyDataSourceMessage: this.t('noRecordsToDisplay'),
                                                },
                                            }}
                                        />
                                    </Grid>    
                                </>
                            )}
                        </Grid>
                    </DialogContent>
                    <Divider />
                    <DialogActions>
                        <Button variant="contained" onClick={() => this.closeDialog()} color="primary">
                            {this.t('close')}
                        </Button>
                    </DialogActions>
                </Dialog>
                {this.state.editRedPacketDialog && 
                    <RedPacketDialog
                        options={this.state.redPacketDialogOptions}
                        closeDialog={()=>{
                            this.setState({
                                editRedPacketDialog: false
                            })
                        }}
                        queryData={() => this.queryData()}
                    />
                }
                {this.state.editDragonBoardDialog && 
                    <DragonBoardDialog
                        options={this.state.dragonBoardDialogOptions}
                        closeDialog={()=>{
                            this.setState({
                                editDragonBoardDialog: false
                            })
                        }}
                        queryData={() => this.queryData()}
                    />
                }
                {this.state.editTigerBoardDialog && 
                    <TigerBoardDialog
                        options={this.state.tigerBoardDialogOptions}
                        closeDialog={()=>{
                            this.setState({
                                editTigerBoardDialog: false
                            })
                        }}
                        queryData={() => this.queryData()}
                    />
                }
                <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
            </>
        )
    }
}

const styles = (theme) => {
    return {
        select: {
            margin: theme.spacing(1),
            width: '150px',
        },
        textField: {
            margin: theme.spacing(1),
            width: '150px',
        },
        textField2: {
            margin: theme.spacing(1),
            width: '175px',
        },
        button: {
            margin: theme.spacing(1),
        },
        tableHeader: {
            textAlign: 'center',
            fontSize: 16,
            fontWeight: 'bold',
            paddingBottom: 8
        },
        actionsBtn: {
            cursor: 'pointer',
            marginLeft: 10,
            marginRight: 10,
            '&:hover': {
                opacity: '0.7'
            }
        }

    }
}

EventDoppelgangerDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    closeDialog: PropTypes.func,
    doppelganger: PropTypes.object,
}

export default hoc(styles)(EventDoppelgangerDialog)
